/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import { PAGE_TYPE } from "./constants";
import { withStoryPageContent } from "./component-bundles/bundling-utils";
const { pickComponent, getChunkName } = pickComponentHelper(
  {
    [PAGE_TYPE.HOME_PAGE]: { chunk: "home", component: "HomePage" },
    [PAGE_TYPE.SECTION_PAGE]: { chunk: "list", component: "SectionPage" },
    [PAGE_TYPE.TAG_PAGE]: { chunk: "list", component: "TagPage" },
    [PAGE_TYPE.SEARCH_PAGE]: { chunk: "list", component: "SearchPage" },
    [PAGE_TYPE.STORY_PAGE]: { chunk: "story", component: "StoryPage" },
    [PAGE_TYPE.CATALOG_PAGE]: { chunk: "list", component: "CatalogPage" },
    [PAGE_TYPE.STORY_PREVIEW]: {
      chunk: "story",
      component: "StoryPagePreview"
    },
    [PAGE_TYPE.STORY_PUBLIC_PREVIEW_PAGE]: {
      chunk: "story",
      component: "StoryPublicPagePreview"
    },
    [PAGE_TYPE.HOME_PREVIEW]: { chunk: "home", component: "HomePagePreview" },
    [PAGE_TYPE.AUTHOR_PAGE]: { chunk: "list", component: "AuthorPage" },
    [PAGE_TYPE.COLLECTION_PAGE]: { chunk: "list", component: "CollectionPage" },
    [PAGE_TYPE.PB_STORY_PREVIEW_PAGE]: {
      chunk: "story",
      component: "StoryPage"
    },
    [PAGE_TYPE.PB_COLLECTION_PREVIEW_PAGE]: {
      chunk: "home",
      component: "PbPreview"
    },
    [PAGE_TYPE.PB_SECTION_PREVIEW_PAGE]: {
      chunk: "list",
      component: "SectionPage"
    },
    [PAGE_TYPE.SUBSCRIPTION]: {
      chunk: "subscription",
      component: "Subscription"
    },
    [PAGE_TYPE.USER_DETAILS]: {
      chunk: "subscription",
      component: "UserDetails"
    },
    [PAGE_TYPE.AUTHORS_PAGE]: { chunk: "list", component: "AuthorsPage" },
    [PAGE_TYPE.PB_AUTHORS_PREVIEW_PAGE]: { chunk: "list", component: "AuthorsPage" },
    [PAGE_TYPE.MAGAZINE_ISSUES_PAGE]: { chunk: "list", component: "MagazineIssuesPage" },
    default: { chunk: "list", component: "NotFoundPage" }
  },
  {
    list: () => import(/* webpackChunkName: "list" */ "./component-bundles/list.js"),
    story: () => import(/* webpackChunkName: "story" */ "./component-bundles/story.js"),
    home: () => import(/* webpackChunkName: "home" */ "./component-bundles/home.js"),
    subscription: () => import(/* webpackChunkName: "subscription" */ "./component-bundles/subscription.js")
  },
  {
    story: withStoryPageContent
  }
);

function pickComponentHelper(components, loadChunk, chunkComponentWrapperFns) {
  return {
    pickComponent,
    getChunkName
  };

  function pickComponent(pageType, subPageType) {
    const { chunk, component } = components[pageType] || components.default;
    return loadChunk[chunk]()
      .then(bundle => {
        if (chunkComponentWrapperFns[chunk]) {
          return chunkComponentWrapperFns[chunk](bundle[component], subPageType);
        }
        return bundle[component];
      })
      .then(comp => comp);
  }

  function getChunkName(pageType) {
    const { chunk } = components[pageType] || components.default;
    return chunk;
  }
}
export { pickComponent, getChunkName };
